import type {
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  FC,
  PropsWithChildren,
} from 'react';
import { Container } from './style';

export type OutlineButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

const OutlineButton: FC<PropsWithChildren<OutlineButtonProps>> = ({
  children,
  type = 'button',
  ...props
}) => {
  return (
    <Container type={type} {...props}>
      {children}
    </Container>
  );
};

export default OutlineButton;
